import UserList from 'features/ContractDetails/ContractDetailsGeneral/ResponsibleUsers/UserList/UserList'
import AddResponsibleBtn from '../Actions/AddResponsibleBtn'
import ContractResponsibleContextProvider from 'features/ContractDetails/ContractDetailsGeneral/ResponsibleUsers/Providers/ContractResponsibleContextProvider'
import {
  Typography,
  TYPOGRAPHY_WEIGHT
} from '../../../../components/Typography'
import { DeleteResponsibleUserPopup } from 'features/ContractDetails/ContractDetailsGeneral/ResponsibleUsers/index'
import { ViewNotePopup } from './ViewNote/ViewNotePopup'
import { useContractDetailsContext } from '../../Providers/ContractDetailsContextProvider'
import 'features/ContractDetails/ContractDetailsGeneral/ResponsibleUsers/styles.scss'

const ResponsibleUsers = () => {
  const contractDetails = useContractDetailsContext()
  const { isVendor } = contractDetails.state
  return (
    <ContractResponsibleContextProvider>
      <div className="contract-details-responsible contract-details-responsible--no-margin gap-24">
        {isVendor && (
          <>
            <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.BOLD}>
              Vendor contacts
            </Typography.Headline6>
            <UserList vendor={isVendor} />
            <div className="contract-details-general__add-responsible">
              <AddResponsibleBtn />
            </div>
          </>
        )}
        {!isVendor && (
          <>
            <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.BOLD}>
              Vendor contacts
            </Typography.Headline6>
            <UserList vendor={!isVendor} />
          </>
        )}
      </div>
      <DeleteResponsibleUserPopup />
      <ViewNotePopup />
    </ContractResponsibleContextProvider>
  )
}

export default ResponsibleUsers
